import React from 'react';
import { useParams } from 'react-router-dom';

import ToggleOption from '@/components/common/ToggleOption/ToggleOption';
import { EDITABLE_STATUS_KEYS, VARIABLE_TYPE } from '@/config/statuses.config';
import useGetContractDetails from '@/hooks/contract/useGetContractDetails.hook';
import useToggleReseller from './hooks/useToggleReseller';

export default function ResellerContainer() {
  const { contractId }: { contractId: UUID } = useParams();
  const { contract } = useGetContractDetails(contractId);
  const { toggleReseller } = useToggleReseller(contractId);

  const isVisibleOption = contract &&
    EDITABLE_STATUS_KEYS.includes(contract?.status.status) &&
    !contract.billingType.includes(VARIABLE_TYPE);

  return (
    <>
      {isVisibleOption ? (
        <ToggleOption
          id="reseller"
          title="Reseller"
          onChange={() => toggleReseller(!Boolean(contract?.reseller))}
          isEnable={Boolean(contract?.reseller)}
        />
      ) : null}
    </>
  );
}
